import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

const AnalyticsTracker: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        logEvent(analytics, 'page_view', {
            page_path: location.pathname,
            page_title: document.title || 'Garden Planner',
        });
    }, [location]);

    return null;
};

export default AnalyticsTracker;
